module.exports = "/_next/static/images/pasta-addbd79aa79255e75013e63cb2825034.jpg";